import { useLightMode } from '@/hooks/useLightMode'

import { BadgeCounter, Grid } from '@hivewatch/dark'

interface IncidentsDrawerTitleIProps {
  title: string
  showCount?: boolean
  totalCount: number
}

export const IncidentsDrawerTitle = ({
  title,
  showCount = false,
  totalCount,
}: IncidentsDrawerTitleIProps) => {
  const colorScheme = useLightMode()

  return (
    <Grid
      alignItems='center'
      gap='2'
      justifyContent='start'
      templateColumns='auto auto'
    >
      {title}
      {showCount && (
        <BadgeCounter
          colorScheme={colorScheme}
          count={totalCount}
          variant='incident'
        />
      )}
    </Grid>
  )
}
